export default {
    props: {
        showTitle: {
            type: Boolean,
            required: false,
            default: true,
        },
        filter: {
            type: Object,
            required: true,
        },
        value: {
            type: [String, Number, Boolean, Object],
            required: true,
        },
        hasResults: {
            type: [String, Boolean],
            default: false,
        },
        forceShowAll: { // See enum
            type: Boolean,
            default: true,
        },
        isShort: { // Short version of the filters, like popup in the enum filter
            type: Boolean,
            default: false,
        },
        symbol: {
            type: String,
            default: '',
        },
    },
    computed: {
        filterLabel() {
            const title = this.$t(`filters.byType.${this.filter.name}`);
            return title ? (title.title || title.label) || this.filter.name : this.filter.name;
        },
        filterValue() {
            return this.value;
        },
        isActiveTopFiltersPosition() {
            return this.$configuration?.layout?.filterPosition === 'top';
        },
    },
    methods: {
        onChange(value = {}) {
            this.$emit('change', { field: this.filter.name, ...value });
        },
        onFilterClick(event, params = {}) {
            const trackParams = {
                field: this.filter.name,
                ...params,
            };

            this.$emit('filter-click', { type: 'filterClick', event, paramsClick: trackParams });
        },
        getNumberByString(string) {
            if (!this.$configuration.hasConvertStringFiltersValuesToNumber) {
                return string;
            }
            if ((string && Number(string)) || Number(string) === 0) {
                return Number(string);
            }
            return string;
        },
    },
};
